import CBSECorner from "../components/pages/CBSECorner";

export default CBSECorner;
